import {
  Edit,
  CardActions,
  ListButton,
  RefreshButton,
  translate
} from "react-admin";
import React from "react";

import FacilitiesForm from "./FacilitiesForm";

const FacilitiesTitle = ({ translate, record }) => {
  return (
    <span>
      {`${translate("facilities.facilities")}`}{" "}
      {record ? `"${record.name}"` : ""}
    </span>
  );
};

const Title = translate(FacilitiesTitle);

const Actions = ({ basePath, data, resource }) => (
  <CardActions>
    <ListButton basePath={basePath} />
    {/* <DeleteButton basePath={basePath} record={data} resource={resource} /> */}
    <RefreshButton />
  </CardActions>
);

export const FacilitiesEdit = props => (
  <Edit actions={<Actions />} title={<Title />} {...props}>
    <FacilitiesForm />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/facilities/FacilitiesEdit.js